import React from "react";
import Mockman from "mockman-js";

function MockAPI() {
  return (
      <>
    <div className="MockAPI" style={{margin: "8rem 0 2rem 0"}}>
      <Mockman />
    </div>
    </>
  );
}

export default MockAPI;